module.exports = __webpack_public_path__ + "static/media/map-b2g.c6750a9a.png";